export default "__VITE_ASSET__PAJX_3kE__"